import React from 'react';
import closeIcon from '../../../static/icons/close-icon.svg';
import { BulkUploadWizardStepper } from './BulkUploadStepper';
import {
  BulkUploadBackButton,
  BulkUploadContinueButton,
  BulkUploadWizard,
  BulkUploadWizardBody,
  BulkUploadWizardClose,
  BulkUploadWizardFooter,
  BulkUploadWizardHeader,
  BulkUploadWizardHeaderActions,
  BulkUploadWizardTitle,
} from '../styles';

const DEFAULT_WIZARD_STEPS = [
  { id: 1, label: 'Add question' },
  { id: 2, label: 'Add responses' },
  { id: 3, label: 'Organise pages' },
  { id: 4, label: 'Review' },
  { id: 5, label: 'Marking rubrics' },
];

export const BulkUploadWizardShell = ({
  currentStep = 1,
  steps = DEFAULT_WIZARD_STEPS,
  onBack,
  onClose,
  onContinue,
  onStepClick,
  continueLabel = 'Continue',
  continueIcon,
  isContinueDisabled = false,
  isBackDisabled = false,
  showBack,
  hideFooter = false,
  // A step that advances itself has no Continue to offer — but it still has a
  // Back. Hiding the whole footer to lose the one button took the other with it.
  hideContinue = false,
  fullPage = false,
  children,
  ...dataAttributes
}) => {
  const shouldShowBack = showBack ?? currentStep > 1;

  return (
    <BulkUploadWizard $fullPage={fullPage} {...dataAttributes}>
      <BulkUploadWizardHeader>
        <BulkUploadWizardTitle>Bulk upload</BulkUploadWizardTitle>
        <BulkUploadWizardHeaderActions>
          <BulkUploadWizardStepper steps={steps} currentStep={currentStep} onStepClick={onStepClick} />
          <BulkUploadWizardClose type="button" aria-label="Close" onClick={onClose}>
            <img src={closeIcon} alt="" width={20} height={20} />
          </BulkUploadWizardClose>
        </BulkUploadWizardHeaderActions>
      </BulkUploadWizardHeader>
      <BulkUploadWizardBody>{children}</BulkUploadWizardBody>
      {!hideFooter && (
        <BulkUploadWizardFooter>
          {shouldShowBack ? (
            <BulkUploadBackButton
              type="button"
              onClick={onBack}
              disabled={isBackDisabled}
              data-testid="bulk-upload-back-button"
            >
              Back
            </BulkUploadBackButton>
          ) : (
            <span />
          )}
          {hideContinue ? (
            <span />
          ) : (
            <BulkUploadContinueButton
              type="button"
              onClick={onContinue}
              disabled={isContinueDisabled}
              data-testid="bulk-upload-continue-button"
              data-disabled={isContinueDisabled}
            >
              {continueIcon && <img src={continueIcon} alt="" width={20} height={20} />}
              {continueLabel}
            </BulkUploadContinueButton>
          )}
        </BulkUploadWizardFooter>
      )}
    </BulkUploadWizard>
  );
};
